export default "__VITE_ASSET__d0fd14a8__"